import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyChooseShipAndStorageSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/drop-off-sports-gear-storage-page'

interface DropOffSportsGearStoragePageProps {}

const DropOffSportsGearStoragePage: React.FC<DropOffSportsGearStoragePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[342px] xl-min:!h-[50px] w-[294px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='
        lg-mn:[&_button]:w-[311px]
        [&_button]:w-[250px]
      '
        sectionTitleClassName='md-mn:w-full w-[90%]'
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
      />
      <WhyWeSection
        isBgDark
        {...whyChooseShipAndStorageSectionContent}
        className='
            [&_article]:bg-transparent
            [&_article]:border-none
            [&_article]:text-center
            [&_article>div]:self-center
      '
        imgClassName='w-[130px] h-[130px]'
        sectionTitleClassName='w-ful'
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionContent}
        className={`
            [&_article]:text-center
            [&_article>div]:self-center
          `}
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          lg-mn:[&_button]:w-[333px]
          [&_button]:w-[292px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default DropOffSportsGearStoragePage
